import { FusionError, serializeFusionError } from '@fusion-advantage/backcompat'
import { sqlQuery, sqlRun } from "./ldb"
import { err, ok, Result } from "neverthrow"
import { selectAllPrettyJson } from "./LdbBrowser"

export type ApptEncounter = {
	serviceApptId: string
	encounterGuid: string|null
	error: string|null
}

export const selectAllApptEncounterJson = async (): Promise<string> => {
	return selectAllPrettyJson('apptEncounter', ['serviceApptId', 'encounterGuid', 'error'])
}

// see also: dal2 ApptEncounterGuidSelector
export const selectApptEncounters = async (upn: string): Promise<Result<ApptEncounter[], FusionError>> => {
	let r = await sqlQuery<ApptEncounter>(
		`
			select serviceApptId, encounterGuid, error
			  from apptEncounter
			 where upn = ?
		`,
		[
			upn,
		],
	)
	if(r.isErr()) {
		return err(serializeFusionError('selectApptEncounters', r.error))
	}
	return ok(r.value)
}

export const replaceApptEncounters = async (upn: string, items: ApptEncounter[]): Promise<Result<void, FusionError>> => {
	let r = await sqlRun(
		`
			delete from apptEncounter
			 where upn = ?
		`,
		[
			upn,
		],
	)
	if(r.isErr()) {
		return err(serializeFusionError('replaceApptEncounters', r.error))
	}
	for(let item of items) {
		r = await sqlRun(
			`
				insert into apptEncounter (serviceApptId, upn, encounterGuid, error)
				values (?, ?, ?, ?)
			`,
			[
				item.serviceApptId,
				upn,
				item.encounterGuid,
				item.error,
			],
		)
		if(r.isErr()) {
			return err(serializeFusionError('replaceApptEncounters', r.error))
		}
	}
	return ok()
}
